import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleCommentExecutive = {
  namespaced: true,

  state: {
    name: 'comment-executive',
    
    comments: []
  },

  mutations,
  getters,
  actions
}

export default moduleCommentExecutive;